import { LINKS } from "../../../config/links";

import { ReactComponent as OneSideIcon } from "./icons/cruiseIcons/1sideIcon.svg";
import { ReactComponent as TwoSideIcon } from "./icons/cruiseIcons/2sidesIcon.svg";
import { ReactComponent as RoundIcon } from "./icons/cruiseIcons/RoundIcon.svg";
import { ReactComponent as CruiseBikeIcon } from "./icons/cruiseIcons/bicycle-54.svg";
import { ReactComponent as CruiseTrailerIcon } from "./icons/cruiseIcons/bicycle-trailer-svgrepo-com.svg";
import { ReactComponent as VipIcon } from "./icons/cruiseIcons/vip.svg";
import { ReactComponent as BikeIcon } from "./icons/bikesIcons/bicycle-54.svg";
import { ReactComponent as ElectricBikeIcon } from "./icons/bikesIcons/bicycle-electric-svgrepo-com.svg";
import { ReactComponent as TrailerIcon } from "./icons/bikesIcons/bicycle-trailer-svgrepo-com.svg";
import { ReactComponent as SeatIcon } from "./icons/bikesIcons/car-seat-with-seatbelt-svgrepo-com.svg";
import { ReactComponent as HelmetIcon } from "./icons/bikesIcons/bicycle-helmet-svgrepo-com.svg";
import { ReactComponent as BoatsIcon } from "./icons/boatsIcons/boat-icon.svg";

const ICONS = {
    oneSide: OneSideIcon,
    twoSide: TwoSideIcon,
    round: RoundIcon,
    cruiseBike: CruiseBikeIcon,
    cruiseTrailer: CruiseTrailerIcon,
    vip: VipIcon,

    bike: BikeIcon,
    electricBike: ElectricBikeIcon,
    trailer: TrailerIcon,
    seat: SeatIcon,
    helmet: HelmetIcon,

    boat: BoatsIcon,
};

export const PRICE_TABLES = {
    cruises: {
        wrapperId: "price-table",
        titleKey: "cruises.title",
        typeLabelKey: "cruises.columns.type",

        columns: [
            { key: "normal", labelKey: "cruises.columns.normal" },
            { key: "discount", labelKey: "cruises.columns.discount" },
        ],

        rows: [
            { key: "oneWay", icon: "oneSide", values: ["18 PLN", "15 PLN"] },
            { key: "twoWays", icon: "twoSide", values: ["36 PLN", "30 PLN"] },
            { key: "roundTrip", icon: "round", values: ["40 PLN", "34 PLN"] },
            { key: "passengerWithBike", icon: "cruiseBike", values: ["28 PLN", "-"] },
            { key: "bikeTrailerTransport", icon: "cruiseTrailer", values: ["15 PLN", "-"] },
            { key: "vipRental", icon: "vip", values: ["450 PLN", "-"] },
        ],

        notes: {
            linesKeys: [
                "cruises.notes.childFree",
                "cruises.notes.groupsReservation",
                "cruises.notes.groupsNegotiation",
                "cruises.notes.vatInvoice",
            ],
            strongLineIndex: 0,
        },
        icons: ICONS,
    },

    bikesRental: {
        wrapperId: "price-table",
        titleKey: "bikesRental.title",

        columns: [
            { key: "upTo3h", labelKey: "bikesRental.columns.upTo3h" },
            { key: "fullDay", labelKey: "bikesRental.columns.fullDay" },
        ],

        rows: [
            { key: "classicBike", icon: "bike", values: ["50 PLN", "60 PLN"] },
            { key: "electricBike", icon: "electricBike", values: ["150 PLN", "200 PLN"] },
            { key: "trailer", icon: "trailer", values: ["-", "60 PLN"] },
            { key: "childSeat", icon: "seat", values: ["-", "30 PLN"] },
            { key: "helmet", icon: "helmet", values: ["-", "10 PLN"] },
        ],

        notes: {
            linesKeys: ["bikesRental.notes.dayDefinition", "bikesRental.notes.freeGondola"],
            strongLineIndex: 1,
        },

        contactBlocks: [
            {
                type: "contact",
                headerKey: "bikesRental.contact.header",
                textKey: "bikesRental.contact.text",
                links: [
                    { kind: "phone", href: LINKS.contact.bikesRentalPhone, displayKey: "bikesRental.contact.phoneDisplay" },
                    { kind: "email", href: LINKS.contact.bikesRentalEmail, displayKey: "bikesRental.contact.emailDisplay" },
                ],
            },
            {
                type: "locationSingle",
                headerKey: "bikesRental.address.header",
                textKeys: ["bikesRental.address.name", "bikesRental.address.street", "bikesRental.address.city"],
                links: [{ kind: "maps", href: LINKS.external.bikesRentalMaps, labelKey: "bikesRental.address.navigate" }],
            },
        ],

        icons: ICONS,
    },

    boats: {
        wrapperId: "price-table",
        titleKey: "boats.title",

        columns: [
            { key: "persons", labelKey: "boats.columns.persons" },
            { key: "pricePerHour", labelKey: "boats.columns.pricePerHour" },
        ],

        rows: [
            { key: "catamaran", icon: "boat", values: ["4", "150 PLN"] },
            { key: "electricBoat", icon: "boat", values: ["8", "300 PLN"] },
        ],

        notes: null,
        contactBlocks: null,

        icons: ICONS,
    },
};